import { useCompanyConsultations } from '../../../../../hooks/fetchers/useCompanyConsultations/useCompanyConsultations';
import DashboardLayout from '../../../../commons/DashboardLayout/DashboardLayout';
import moment from 'moment';
import Chip from '../../../../designSystem/Chip/Chip';
import { getChipContentByStepId } from '../../../../../utils/helpers/consultation/getChipContentByStepId';
import { useState } from 'react';

export default () => {
  const [currentPage] = useState<number>(1);
  const [itemsPerPage] = useState<number>(11);

  const { data } = useCompanyConsultations({ page: currentPage, perPage: itemsPerPage });

  return (
    <DashboardLayout>
      <table className="dashboard__table dashboard-invoices__table">
        <colgroup>
          <col style={{ width: '60%' }} />
          <col />
          <col />
        </colgroup>
        <thead>
          <tr>
            <th>Titre</th>
            <th>Début</th>
            <th>Fin</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          {data?.results.map((consultation, index) => {
            const { title, start, end } = consultation;
            const { label, color } = getChipContentByStepId(consultation);
            return (
              <tr key={index}>
                <td>{title}</td>
                <td>{moment(start).format('DD-MM-YYYY')}</td>
                <td>{moment(end).format('DD-MM-YYYY')}</td>
                <td>
                  <Chip {...{ color }}>{label}</Chip>
                </td>
                {/* <td>{id_step}</td> */}
              </tr>
            );
          })}
        </tbody>
      </table>
    </DashboardLayout>
  );
};
